
// ---------------------------------
// Base
// ---------------------------------


// Init

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define([], factory);
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        root.framework = factory();
    }
}(this, function () {
    "use strict";
    
var self = {};

self.nodeElement = function (selector) {
    return typeof selector === 'string' ? document.querySelectorAll(selector) : selector;
};

var _element = document.createElement('div');
var _elementStyle = _element.style;
var _vendor = (function () {
    var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
        transform,
        i = 0,
        l = vendors.length;

    for (; i < l; i++) {
        transform = vendors[i] + 'ransform';
        if (transform in _elementStyle) return vendors[i].substr(0, vendors[i].length - 1);
    }
    return false;
})();

self.extend = function (target, obj) {
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
            target[i] = obj[i];
        }
    }
};

self.prefixStyle = function (style) {
    if (_vendor === false) return false;
    if (_vendor === '') return style;
    return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
};

self.pregQuote = function (str, delimiter) {
    return (str + '').replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&');
};

// Event
// ---------------------------------

self.passiveSupported = function () {
    var passiveSupported = false;
    window.addEventListener("test", null, Object.defineProperty({}, "passive", { get: function () { passiveSupported = true; } }));
    return passiveSupported ? { passive: false } : false;
};

self.addEvent = function (el, type, fn, capture) {
    el.addEventListener(type, fn, capture || self.passiveSupported());
};

self.removeEvent = function (el, type, fn, capture) {
    el.removeEventListener(type, fn, capture || false);
};

self.on = function (el, type, fn, capture) {
    var i = 0,
        t = type.split(' '),
        l = t.length;
    for (; i < l; ++i) {
        if (t[i]) {
            self.addEvent(el, t[i], fn, capture);
        }
    }
};

self.off = function (el, type, fn, capture) {
    var i = 0,
        t = type.split(' '),
        l = t.length;
    for (; i < l; ++i) {
        if (t[i]) {
            self.removeEvent(el, t[i], fn, capture);
        }
    }
};

self.trigger = function (el, targetEvt) {
    var evt;
    if (document.createEvent) {
        evt = document.createEvent("HTMLEvents");
        evt.initEvent(targetEvt, true, true);
        return el.dispatchEvent(evt);
    } else {
        evt = document.createEventObject();
        return el.fireEvent("on" + targetEvt, evt);
    }
};

// Node
// ---------------------------------

self.each = function (el, fn) {
    if (el && !('length' in el)) el = [el];
    var i = 0,
        l = el.length;
    if (l) {
        for (; i < l; ++i) {
            fn(i, el[i]);
        }
    }
};

self.wrap = function (el, wrapEl) {
    el.parentNode.insertBefore(wrapEl, el);
    wrapEl.appendChild(el);
};

self.unwrap = function (el) {
    while (el.firstChild) {
        el.parentNode.insertBefore(el.firstChild, el);
    }
    el.remove();
};

self.closest = function (el, selector) {
    return (el.closest || function (_selector) {
        do {
            if ((el.matches || el.msMatchesSelector).call(el, _selector)) {
                return el;
            }
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    }).call(el, selector);
};

self.parent = function (el, selector) {
    if (selector) {
        return el.parentNode;
    } else {
        return framework.closest(el, selector);
    }
};

// Attribute
// ---------------------------------

self.hasClass = function (el, className) {
    return el.className && new RegExp('(^|\\s)' + self.pregQuote(className) + '(\\s|$)').test(el.className);
};

self.addClass = function (el, className) {
    if (self.hasClass(el, className)) {
        return;
    }
    el.className += (el.className ? ' ' : '') + className;
};

self.removeClass = function (el, className) {
    if (!self.hasClass(el, className)) {
        return;
    }
    var reg = new RegExp('(\\s|^)' + self.pregQuote(className) + '(\\s|$)');
    el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
};

self.toggleClass = function (el, className) {
    if (framework.hasClass(el, className)) {
        framework.removeClass(el, className);
    } else {
        framework.addClass(el, className);
    }
};

// Style (css)

self.getStyle = function (el, prop) {
    var style = el.currentStyle || document.defaultView.getComputedStyle(el, '');
    if (prop) {
        return String(style.getPropertyValue(self.prefixStyle(prop))).trim();
    } else {
        return style;
    }
};

self.setStyle = function (el, prop, val) {
    el.style[self.prefixStyle(prop)] = val || null;
};

self.getCustomProperty = function (prop) {
    return self.getStyle(document.documentElement, prop);
};

self.setCustomProperty = function (prop, defaultValue) {
    var value = self.getCustomProperty(prop);
    return value || defaultValue;
};

// Support
// ---------------------------------

self.extend(self, {
    hasTransform: self.prefixStyle('transform') !== false,
    hasPerspective: self.prefixStyle('perspective') in _elementStyle,
    hasTransition: self.prefixStyle('transition') in _elementStyle,
    hasTouch: 'ontouchstart' in window,
    hasPointer: !!(window.PointerEvent || window.MSPointerEvent),
});

self.extend(self, {
    hasTransform: self.prefixStyle('transform') !== false,
    hasPerspective: self.prefixStyle('perspective') in _elementStyle,
    hasTransition: self.prefixStyle('transition') in _elementStyle,
    hasTouch: 'ontouchstart' in window,
    hasPointer: !!(window.PointerEvent || window.MSPointerEvent),
});

var ua = navigator.userAgent;

self.extend(self.ua = {}, {
    isIe: ua.match(/MSIE/i) || ua.match(/Trident/i),
    isEdge: ua.match(/Edge/i),
    isFireFox: ua.match(/Firefox/i) != null,
    isChrome: ua.match(/Chrome/i),
    isSafari: ua.match(/Safari/i) && !self.ua.isChrome && !self.ua.isEdge,
});

self.extend(self, {
    windowScrollTarget: ('scrollingElement' in document) ? document.scrollingElement : (ua.toLowerCase().match(/webkit|msie 5/)) ? document.body : document.documentElement,
    mouseWheelEvent: "onwheel" in _element ? "wheel" : document.onmousewheel !== undefined ? "mousewheel" : "DOMMouseScroll",
});

// Various
// ---------------------------------

self.offset = function (el) {
    var rect = el.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft;
    return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft
    };
};

self.getScrollTop = function () {
    return (typeof window.pageYOffset === "number") ? window.pageYOffset : self.windowScrollTarget.scrollTop;
};

// Animation
// ---------------------------------

self.extend(self.value = {}, {
    duration: 400,
    animationFrameTime: (1000.0 / 60),
});

self.requestAnimationFrame = function (fn, time) {
    var request = window[self.prefixStyle('requestAnimationFrame')] || window.setTimeout;
    return request(fn, time);
};
self.cancelAnimationFrame = function (fn) {
    var cancel = window[self.prefixStyle('cancelAnimationFrame')] || window.clearTimeout;
    return cancel(fn);
};

// Thanks easing_functions
// https://gist.github.com/creotiv/effdedbe7c5526a493bf
//
// t: current time, b: beginning value, c: change in value, d: duration
self.easing = function (t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t + b; return c / 2 * ((t -= 2) * t * t + 2) + b;
};

self.scrollAnimation = function (to, from, duration, easing, cb) {
    if (isNaN(parseInt(to))) to = 0;
    if (!from) from = self.getScrollTop();
    if (!duration) duration = self.value.duration;
    if (!easing) easing = self.easing;
    to = parseInt(to) - from;
    var animLoop, startTime = Date.now();
    (function loop() {
        var currentTime = Date.now() - startTime;
        if (currentTime < duration) {
            scrollTo(0, easing(currentTime, from, to, duration));
            animLoop = self.requestAnimationFrame(loop, self.value.animationFrameTime);
        } else {
            scrollTo(0, to + from);
            self.cancelAnimationFrame(animLoop);

            // Callback
            if (typeof (cb) == "function") {
                cb();
            }
        }
    })();
};

return self;

;
}));;

;

// Modules
// ---------------------------------
// PollyFill
// ---------------------------------

function PollyFill(_options) {

    "use strict";

    // Insert framework

    function supportScrollTo() {
        return ('scrollTo' in window) ? true : false;
    }

    function supportScrollBehavior() {
        if ('scrollBehavior' in document.documentElement.style) {
            return true;
        } else {
            return false;
        }
    }

    function supportIntersectionObserver() {
        return ('IntersectionObserver' in window) ? true : false;
    }

    function supportStickyPosition() {
        var prop = 'position:';
        var value = 'sticky';
        var elStyle = document.createElement('div').style;
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        elStyle.cssText = prop + prefixes.join(value + ';' + prop).slice(0, -prop.length);
        return elStyle.position.indexOf(value) !== -1;
    }

    // ---------------------------------
    // Options
    // ---------------------------------

    this.options = {

        windowScrollTarget: framework.windowScrollTarget,

        // Smooth Scroll
        smoothScrollDuration: framework.value.duration,
        smoothScrollNegativeValue: 0,
        smoothScrollBrowserHash: false,
        smoothScrollExcludeElements: null,
        useScrollTo: true,

        // Sticky position
        stickyPositionTarget: '.sticky',
        stickyPositionInitClass: 'init-sticky',
        stickyPositionTopClass: 'sticky-top',
        stickyPositionBottomClass: 'sticky-bottom',
        stickyPositionClass: 'is-sticky',
        stickyPositionLandClass: 'sticky-land',
        stickyPositionSentinalClass: 'sticky-sentinal',
        stickyPositionBreakpointMinHeight: parseFloat(framework.setCustomProperty('--breakpoint-sticky-min-height', 700)),
    };

    // Overwrite parameters
    for (var key in _options) {
        if (_options.hasOwnProperty(key)) {
            this.options[key] = _options[key];
        }
    }

    var that = this;

    // ---------------------------------
    // Functions
    // ---------------------------------

    function focusTarget(el) {
        el.focus();
        if (document.activeElement !== el) {
            el.tabIndex = -1;
            el.focus();
        }
    }

    function removeHash() {
        var uri = window.location.toString();
        if (uri.indexOf("#") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("#"));
            window.history.replaceState({}, document.title, clean_uri);
        }
    }

    function isKeyboadEvents(event) {
        return event.ctrlKey || event.shiftKey || event.altKey || event.metaKey;
    }

    // Smooth scroll
    // ---------------------------------

    var scrollToAnimation = function (to, from, duration, easing) {
        if (that.options.useScrollTo && supportScrollTo()) {
            window.scrollTo({
                top: to,
                behavior: "smooth"
            });
        } else {
            framework.scrollAnimation(to, from, that.options.smoothScrollDuration);
        }
    };

    var smoothScrollStatusEvent = function (e) {
        var selector = e.target.hash;
        if (selector && !isKeyboadEvents(e)) {

            // Exclude elements
            if (that.smoothScrollExcludeElements) {
                var excludeFlag;
                framework.each(that.smoothScrollExcludeElements, function (i, el) {
                    if (e.target === el) {
                        excludeFlag = true;
                    }
                });
                if (excludeFlag) {
                    e.preventDefault();
                    return false;
                }
            }

            var target = document.querySelectorAll(selector)[0];
            if (!target) return false;

            // Focus target
            if ((/(TEXTAREA|INPUT)/i).test(target.nodeName)) {
                focusTarget(target);
            }
            // Browser hash
            if (!that.options.smoothScrollBrowserHash) {
                setTimeout(function () {
                    removeHash();
                }, 0);
            }
        }
    };

    var smoothScrollPollyfillEvent = function (e) {
        var selector = e.target.hash;
        if (selector && !isKeyboadEvents(e)) {

            e.preventDefault();

            // Exclude elements
            if (that.smoothScrollExcludeElements) {
                var excludeFlag;
                framework.each(that.smoothScrollExcludeElements, function (i, el) {
                    if (e.target === el) {
                        excludeFlag = true;
                    }
                });
                if (excludeFlag) {
                    return false;
                }
            }

            var target = document.querySelectorAll(selector)[0];
            if (!target) return false;

            // Start animation
            var to = target.getBoundingClientRect().top + that.options.smoothScrollNegativeValue;
            var from = window.pageYOffset || options.windowScrollTarget.scrollTop;
            scrollToAnimation(to - from, from, that.options.smoothScrollDuration);
            
            // Focus target
            if ((/(TEXTAREA|INPUT)/i).test(target.nodeName)) {
                focusTarget(target);
            }
            // Browser hash
            if (that.options.smoothScrollBrowserHash) {
                history.pushState({}, '', selector);
            }
        }
    };

    this.destroySmoothScroll = function () {
        if (supportScrollBehavior()) {
            framework.off(document, 'click', smoothScrollStatusEvent);
        } else {
            framework.off(document, 'click', smoothScrollPollyfillEvent);
        }
    };

    this.initSmoothScroll = function () {

        that.smoothScrollExcludeElements = framework.nodeElement(that.options.smoothScrollExcludeElements);
        
        if (supportScrollBehavior()) {
            framework.on(document, 'click', smoothScrollStatusEvent);
        } else {
            framework.on(document, 'click', smoothScrollPollyfillEvent);
        }
    };

    // Sticky position
    // ---------------------------------

    // Determine the type of element
    var isStickyPositionTop = function (el) {
        // Has classname
        if (framework.hasClass(el, that.options.stickyPositionTopClass) && !framework.hasClass(el, that.options.stickyPositionBottomClass)) {
            return true;
        } else if (!framework.hasClass(el, that.options.stickyPositionTopClass) && framework.hasClass(el, that.options.stickyPositionBottomClass)) {
            return false;
        }
        // Find style settings
        var elStyle = el.style;
        if (elStyle.top && !elStyle.bottom) {
            return true;
        } else if (!elStyle.top && elStyle.bottom) {
            return false;
        }
        // Default value
        var elTop = parseInt(framework.getStyle(el, 'top'));
        var div = document.createElement('div');
        if (isNaN(parseInt(framework.getStyle(div, 'top')))) {
            if (!isNaN(elTop)) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    };

    // Reset unnecessary items
    var resetStickyPositionStatus = function (el) {

        // Hide land element
        var land = el.previousElementSibling;
        if (land && framework.hasClass(land, that.options.stickyPositionSentinalClass)) {
            land.style.display = 'none';
        }

        // Reset element status
        el.style.position = '';
        framework.removeClass(el, that.options.stickyPositionInitClass);
        framework.removeClass(el, that.options.stickyPositionClass);
    };

    this.stickyPositionPollyfill = function (el) {

        var parent = el.parentNode;
        var parentStyle = parent.style;
        var elStyle = el.style;

        // Setup element for landing
        var land = el.previousElementSibling;
        if (!land || !framework.hasClass(land, that.options.stickyPositionLandClass)) {
            land = document.createElement('div');
            land.className = that.options.stickyPositionLandClass;
            parent.insertBefore(land, el);
        }

        // Setup Status
        var stickyPosition = 'top';
        var stickyOffsetValue = parseInt(framework.getStyle(el, 'top'));
        if (!isStickyPositionTop(el)) {
            stickyPosition = 'bottom';
            stickyOffsetValue = parseInt(framework.getStyle(el, 'bottom'));
        }

        // Keep elements nother style
        elStyle.position = '';
        elStyle.top = '';
        elStyle.bottom = '';
        var styleAddAttr = el.getAttribute('style') ? ' ' + el.getAttribute('style') : '';

        parentStyle.position = 'relative';
        elStyle.position = 'absolute';
        if (stickyPosition === 'bottom') {
            elStyle.position = 'fixed';
        }

        var scrollTop = 0;
        var stickyTopStart = parseInt(framework.offset(land).top - stickyOffsetValue);
        var stickyTopEnd = parseInt(framework.offset(parent).top + parent.offsetHeight - el.offsetHeight - stickyOffsetValue);

        var scrollBottom = 0;
        var stickyBottomStart = parseInt(framework.offset(parent).top);
        var stickyBottomEnd = parseInt(framework.offset(land).top);

        var stickyPositionClass = that.options.stickyPositionClass;
        var stickyBasePosition = parseInt(framework.offset(land).top - framework.offset(parent).top + stickyOffsetValue);

        var stickerStatus;
        if (stickyPosition === 'top') {
            stickerStatus = function () {

                // Base position
                if (stickyTopStart >= scrollTop) {
                    framework.removeClass(el, stickyPositionClass);
                    el.setAttribute('style', 'position: absolute; top: ' + stickyBasePosition + 'px; bottom: inherit;' + styleAddAttr);
                }
                // Sticky position
                else if (stickyTopStart < scrollTop && stickyTopEnd >= scrollTop) {
                    framework.addClass(el, stickyPositionClass);
                    el.setAttribute('style', 'position: fixed; top: ' + stickyOffsetValue + 'px; bottom: inherit;' + styleAddAttr);
                }
                // Stuck position
                else if (stickyTopEnd < scrollTop) {
                    framework.addClass(el, stickyPositionClass);
                    el.setAttribute('style', 'position: absolute; top: inherit; bottom: 0;' + styleAddAttr);
                }
            };
        } else {
            stickerStatus = function () {
                scrollBottom = parseInt(scrollTop + window.innerHeight - (el.offsetHeight - stickyOffsetValue));

                // Stuck position
                if (stickyBottomStart >= scrollBottom) {
                    framework.removeClass(el, stickyPositionClass);
                    el.setAttribute('style', 'position: absolute; top: 0; bottom: inherit;' + styleAddAttr);
                }
                // Sticky position
                else if (stickyBottomStart < scrollBottom && stickyBottomEnd >= scrollBottom) {
                    framework.addClass(el, stickyPositionClass);
                    el.setAttribute('style', 'position: fixed; top: inherit; bottom: ' + stickyOffsetValue + 'px;' + styleAddAttr);
                }
                // Base position
                else if (stickyBottomEnd < scrollBottom) {
                    framework.addClass(el, stickyPositionClass);
                    el.setAttribute('style', 'position: absolute; top: ' + stickyBasePosition + 'px; bottom: inherit;' + styleAddAttr);
                }
            };
        }

        function sticker() {
            land.style.height = parseInt(el.clientHeight) + 'px';
            land.style.width = parseInt(el.clientWidth) + 'px';
            stickyTopStart = parseInt(framework.offset(land).top - stickyOffsetValue);
            stickyTopEnd = parseInt(framework.offset(parent).top + parent.offsetHeight - el.offsetHeight - stickyOffsetValue);
            stickyBottomStart = parseInt(framework.offset(parent).top);
            stickyBottomEnd = parseInt(framework.offset(land).top);
            scrollTop = parseInt(window.pageYOffset || that.options.windowScrollTarget.scrollTop);
            stickyBasePosition = parseInt(framework.offset(land).top - framework.offset(parent).top + stickyOffsetValue);
            stickerStatus();
        }
        sticker();

        framework.on(window, 'scroll resize', sticker, { passive: true });

        var timer = 0;
        framework.on(window, 'load resize', function (e) {
            var wh = window.innerHeight;
            if (timer > 0) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                if (wh < that.options.stickyPositionBreakpointMinHeight) {
                    framework.each(that.stickyPositionElements, function (index, el) {
                        framework.off(window, 'scroll resize', sticker);
                        resetStickyPositionStatus(el);
                    });
                } else {
                    framework.each(that.stickyPositionElements, function (index, el) {
                        framework.on(window, 'scroll resize', sticker, { passive: true });
                        sticker();
                    });
                }
            }, 200);
        });
    };

    this.stickyPositionObserver = function (el) {

        var parent = el.parentNode;

        // Setup element for monitoring
        var sentinal = el.previousElementSibling;
        if (!sentinal || !framework.hasClass(sentinal, that.options.stickyPositionSentinalClass)) {
            sentinal = document.createElement('div');
            sentinal.className = that.options.stickyPositionSentinalClass;
            parent.insertBefore(sentinal, el);
        }
    };

    this.stickyPosition = function (el) {

        // Setup Status
        var stickyPosition = 'top';
        var stickyOffsetValue = parseInt(framework.getStyle(el, 'top'));
        if (!isStickyPositionTop(el)) {
            stickyPosition = 'bottom';
            stickyOffsetValue = parseInt(framework.getStyle(el, 'bottom'));
        }

        var stickyTop = 0;
        var stickyBottom = 0;
        var stickyPositionClass = that.options.stickyPositionClass;

        var stickerStatus;
        if (stickyPosition === 'top') {
            stickerStatus = function () {
                if (stickyTop <= 0) {
                    framework.addClass(el, stickyPositionClass);
                } else if (stickyTop > 0) {
                    framework.removeClass(el, stickyPositionClass);
                }
            };
        } else {
            stickerStatus = function () {
                if (stickyBottom >= stickyOffsetValue) {
                    framework.addClass(el, stickyPositionClass);
                } else if (stickyTop < 0) {
                    framework.removeClass(el, stickyPositionClass);
                }
            };
        }

        function sticker() {
            stickyTop = parseInt(el.getBoundingClientRect().top - stickyOffsetValue);
            stickyBottom = parseInt(window.innerHeight - el.offsetHeight - stickyTop - stickyOffsetValue);
            stickerStatus();
        }
        sticker();

        framework.on(window, 'scroll resize', sticker, { passive: true });

        var timer = 0;
        framework.on(window, 'load resize', function (e) {
            var wh = window.innerHeight;
            if (timer > 0) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                if (wh < that.options.stickyPositionBreakpointMinHeight) {
                    framework.each(that.stickyPositionElements, function (index, el) {
                        framework.off(window, 'scroll resize', sticker);
                        resetStickyPositionStatus(el);
                    });
                } else {
                    framework.each(that.stickyPositionElements, function (index, el) {
                        framework.on(window, 'scroll resize', sticker, { passive: true });
                        sticker();
                    });
                }
            }, 200);
        });
    };

    // ---------------------------------
    // Method
    // ---------------------------------

    this.init = function () {

        // Smooth scroll
        that.initSmoothScroll();

        // Sticky position
        var initStickyPosition = function (el) {
            return supportStickyPosition() ? supportIntersectionObserver() ? that.stickyPositionObserver(el) : that.stickyPosition(el) : that.stickyPositionPollyfill(el);
        };

        that.stickyPositionElements = framework.nodeElement(that.options.stickyPositionTarget);
        if (that.stickyPositionElements.length) {
            // Handle each of the given elements
            framework.each(that.stickyPositionElements, function (index, el) {
                initStickyPosition(el);
            });
        }

        if (supportIntersectionObserver()) {
            var stickyObserver = function (entries) {
                framework.each(entries, function (index, entry) {
                    if (!entry.isIntersecting) {
                        framework.addClass(entry.target.nextElementSibling, that.options.stickyPositionClass);
                    } else {
                        framework.removeClass(entry.target.nextElementSibling, that.options.stickyPositionClass);
                    }
                });
            };
            var observer = new window.IntersectionObserver(stickyObserver);
            framework.each(that.stickyPositionElements, function (index, el) {
                if (framework.hasClass(el.previousElementSibling, that.options.stickyPositionSentinalClass)) {
                    observer.observe(el.previousElementSibling);
                }
            });
        }
    };

    this.init();
};
// ---------------------------------
// NewsTicker
// ---------------------------------
// Init
//
// var newsTicker = new NewsTicker(selectors, {
//     parentElement: 'ul',
//     childElements: 'li',
//     cursor: '_',
//     allowedTags: ['a', 'b', 'strong', 'span', 'i', 'em', 'u'],

//     itemSpeed: 2000,
//     cursorSpeed: 50,
//     fadeInSpeed: 100,
//     fadeOutSpeed: 200,
//     pauseOnHover: true,
//     finishOnHover: false,

//     // Event classes
//     newsTickerInitClass: 'init-newsticker',
//     newsTickerHoverClass: 'hover-newsticker',

//     // Element classes
//     newsTickerTextClass: 'newsticker-text',
//     newsTickerCursorClass: 'newsticker-cursor',
// });
// ---------------------------------

function NewsTicker(_selectors, _options) {

    "use strict";

    this.selectors = _selectors || '.news-ticker';
    this.elements = null;
    this.elementsLength = null;

    // ---------------------------------
    // Frameworks
    // ---------------------------------

    // import '../../framework/src/framework.js';

    // ---------------------------------
    // Options
    // ---------------------------------

    this.options = {

        parentElement: 'ul',
        childElements: 'li',
        cursor: '_',
        allowedTags: ['a', 'b', 'strong', 'span', 'i', 'em', 'u'],

        itemSpeed: 2000,
        cursorSpeed: 50,
        fadeInSpeed: 100,
        fadeOutSpeed: 200,
        pauseOnHover: true,
        finishOnHover: false,

        // Event classes
        newsTickerInitClass: 'init-newsticker',
        newsTickerHoverClass: 'hover-newsticker',

        // Element classes
        newsTickerTextClass: 'newsticker-text',
        newsTickerCursorClass: 'newsticker-cursor',
    };

    // Overwrite parameters
    for (var key in _options) {
        if (_options.hasOwnProperty(key)) {
            this.options[key] = _options[key];
        }
    }

    var that = this;

    that.animationFrameTime = framework.value.animationFrameTime;

    /**
     * Strip all HTML tags from a string.
     * An array of safe tags can be passed, which will not be
     * stripped from the string with the rest of the tags.
     */
    function stripTags(text, safeTags) {
        safeTags = safeTags || [];
        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/img;
        var comments = /<!--.*?-->/img;
        return text.replace(comments, '').replace(tags, function (a, b) {
            return safeTags.indexOf(b.toLowerCase()) !== -1 ? a : '';
        });
    }

    /**
     * Locates all of the requested tags in a string.
     */
    function locateTags(text, tagList) {
        tagList = tagList || [];
        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/im;
        var selfClosing = /\/\s{0,}>$/m;
        var locations = [];
        var match, location;

        while ((match = tags.exec(text)) !== null) {
            if (tagList.length === 0 || tagList.indexOf(match[1]) !== -1) {
                location = {
                    tag: match[0],
                    name: match[1],
                    selfClosing: selfClosing.test(match[0]),
                    start: match.index,
                    end: match.index + match[0].length - 1
                };
                locations.push(location);
                text = text.slice(0, location.start) + text.slice(location.end + 1);
                tags.lastIndex = 0;
            }
        }

        return locations;
    }
    
    function showElement(el) {
        el.style.display = "inline-block";
        el.style.visibility = "visible";
    }

    function hideElement(el) {
        el.style.display = "none";
        el.style.visibility = "hidden";
    }

    function newsIn(el, ms, callback) {
        if (!el) {
            return;
        }

        showElement(el);

        if (ms) {
            var opacity = 0;
            var timer = setInterval(function () {
                opacity += that.animationFrameTime / ms;
                if (opacity >= 1) {
                    clearInterval(timer);
                    opacity = 1;
                    callback();
                }
                el.style.opacity = opacity;
            }, that.animationFrameTime);
        }
        else {
            el.style.opacity = 1;
            callback();
        }
    }

    function newsOut(el, ms, callback) {
        if (!el) {
            return;
        }

        if (ms) {
            var opacity = 1;
            var timer = setInterval(function () {
                opacity -= that.animationFrameTime / ms;
                if (opacity <= 0) {
                    clearInterval(timer);
                    opacity = 0;
                    hideElement(el);
                    callback();
                }
                el.style.opacity = opacity;
            }, that.animationFrameTime);
        }
        else {
            el.style.opacity = 0;
            hideElement(el);
            callback();
        }
    }

    this.newsShowBefore = function (container, text, cursor) { };
    this.newsShowAfter = function (container, text, cursor) { };

    this.init = function () { 

        // Setup elements
        that.elements = framework.nodeElement(that.selectors);
        that.elementsLength = that.elements.length;

        // If the elements are not found, return
        if (!that.elementsLength) return false;

        // Handle each of the given elements
        framework.each(that.elements, function (index) {

            var newsTicker = that.elements[index];
            var newsTickerElementsParent = newsTicker.querySelectorAll(that.options.parentElement)[0];
            var newsTickerElements = newsTicker.querySelectorAll(that.options.childElements);
            var newsTickerContainer;
            var newsTickerText;
            var newsTickerCursor;

            var childs = [];
            var childTagMap = {};
            var loopTimeoutId;
            var newsTimeoutId;
            var currentChild = 0;
            var currentChildPosition = 0;
            var firstLoop = true;
            var firstNews = true;

            if (!newsTickerElementsParent || !newsTickerElements) return true;

            framework.addClass(newsTicker, that.options.newsTickerInitClass);

            // Setup monitoring hover state
            framework.removeClass(newsTicker, that.options.newsTickerHoverClass);
            framework.on(newsTicker, 'mouseenter', function (e) {
                framework.addClass(newsTicker, that.options.newsTickerHoverClass);
            });
            framework.on(newsTicker, 'mouseleave', function (e) {
                framework.removeClass(newsTicker, that.options.newsTickerHoverClass);
            });

            // Save childs
            var h, l;
            framework.each(newsTickerElements, function (i) {
                h = stripTags(newsTickerElements[i].innerHTML, that.options.allowedTags);
                l = locateTags(h);
                h = stripTags(h);
                childs.push(h);
                childTagMap[childs.length - 1] = l;
            });

            // Create HTML template
            newsTickerText = document.createElement('span');
            newsTickerText.className = that.options.newsTickerTextClass;
            newsTickerElementsParent.parentNode.insertBefore(newsTickerText, newsTickerElementsParent.nextElementSibling);
            newsTickerElementsParent.parentNode.removeChild(newsTickerElementsParent);

            newsTickerContainer = document.createElement('div');
            framework.wrap(newsTickerText, newsTickerContainer);

            newsTickerCursor = document.createElement('span');
            newsTickerCursor.className = that.options.newsTickerCursorClass;
            newsTickerCursor.innerHTML = that.options.cursor;
            newsTickerContainer.appendChild(newsTickerCursor);

            // Hide at first
            hideElement(newsTickerContainer);

            function startNTicker() {
                firstNews = true;

                if (firstLoop) {
                    firstLoop = false;
                    typoNTicker();
                    return;
                }

                loopTimeoutId = setTimeout(function () {
                    if (that.options.pauseOnHover && framework.hasClass(newsTicker, that.options.newsTickerHoverClass)) {
                        clearTimeout(newsTimeoutId);
                        startNTicker();
                        return;
                    }
                    typoNTicker();
                }, that.options.itemSpeed);
            }

            function typoNTicker() {
                if (firstNews) {
                    firstNews = false;

                    loopNTicker();
                    return;
                }

                if (currentChildPosition > childs[currentChild].length) {
                    nextNTicker();
                    return;
                }

                if (that.options.finishOnHover && that.options.pauseOnHover && framework.hasClass(newsTicker, that.options.newsTickerHoverClass) && currentChildPosition <= childs[currentChild].length) {
                    newsTickerText.innerHTML = typoNTickerText();
                    currentChildPosition += 1;

                    typoNTicker();
                    return;
                } else {
                    newsTimeoutId = setTimeout(function () {
                        if (that.options.pauseOnHover && framework.hasClass(newsTicker, that.options.newsTickerHoverClass)) {
                            clearTimeout(newsTimeoutId);
                            typoNTicker();
                            return;
                        }

                        loopNTicker();
                        nextNTicker();
                    }, that.options.cursorSpeed);
                }
            }

            function nextNTicker() {
                if (currentChildPosition > childs[currentChild].length) {
                    currentChild += 1;
                    currentChildPosition = 0;

                    if (currentChild == childs.length) currentChild = 0;

                    clearTimeout(newsTimeoutId);
                    clearTimeout(loopTimeoutId);
                    startNTicker();
                }
            }

            function loopNTicker() {

                if (currentChildPosition === 0) {
                    clearTimeout(newsTimeoutId);

                    newsOut(newsTickerContainer, that.options.fadeOutSpeed, function () {
                        newsTickerText.innerHTML = typoNTickerText();
                        setTimeout(function () {

                            // Set before method
                            that.newsShowBefore(newsTickerContainer, newsTickerText, newsTickerCursor);

                            newsIn(newsTickerContainer, that.options.fadeInSpeed, function () {
                                newsTickerCursor.style.opacity = 1;
                                setTimeout(function () {
                                    currentChildPosition += 1;
                                    typoNTicker();
                                }, 700);
                            });
                        }, 500);
                    });

                } else {

                    // Set after method
                    if (currentChildPosition >= childs[currentChild].length) {
                        that.newsShowAfter(newsTickerContainer, newsTickerText, newsTickerCursor);
                    }

                    newsTickerText.innerHTML = typoNTickerText();
                    currentChildPosition += 1;
                    clearTimeout(newsTimeoutId);
                    typoNTicker();
                }
            }

            function typoNTickerText() {

                var i, j, location;
                var headline = '';
                var openedTags = [];
                
                for (i = 0; i < currentChildPosition; i++) {
                    location = null;
                    for (j = 0; j < childTagMap[currentChild].length; j++) {
                        if (childTagMap[currentChild][j] && childTagMap[currentChild][j].start === i) {
                            location = childTagMap[currentChild][j];
                            break;
                        }
                    }

                    if (location) {
                        headline += location.tag;

                        if (!location.selfClosing) {
                            if (location.tag.charAt(1) === '/') {
                                openedTags.pop();
                            } else {
                                openedTags.push(location.name);
                            }
                        }
                    }

                    headline += childs[currentChild][i];
                }

                for (i = 0; i < openedTags.length; i++) {
                    headline += '</' + openedTags[i] + '>';
                }

                return headline;
            }

            startNTicker();
        });
    };

    this.init();
};
// ---------------------------------
// CrossGallery
// ---------------------------------
// Init
//
// var crossGallery = new CrossGallery({
//     slideItem: '.slide',
//     slideTransitionSpeed: 2000,
//     slideIntarvalTime: 5000,
// });
// ---------------------------------

function CrossGallery(_selectors, _options) {

    "use strict";

    this.selectors = _selectors || '.slide-container';
    this.elements = null;
    this.elementsLength = null;

    // ---------------------------------
    // Frameworks
    // ---------------------------------

    // import '../../framework/src/framework.js';

    // ---------------------------------
    // Options
    // ---------------------------------

    this.options = {

        // Classes
        crossgalleryInitClass: 'init-crossgallery',

        slideItem: '.slide',
        slideTransitionSpeed: parseFloat(framework.setCustomProperty('--slide-transition-speed', 2000)),
        slideIntarvalTime: parseFloat(framework.setCustomProperty('--slide-intarval-time', 7500)),
    };

    // Overwrite parameters
    for (var key in _options) {
        if (_options.hasOwnProperty(key)) {
            this.options[key] = _options[key];
        }
    }

    var that = this;

    that.options.slideIntarvalTime = that.options.slideIntarvalTime - that.options.slideTransitionSpeed;

    this.init = function () {

        // Setup elements
        that.elements = framework.nodeElement(that.selectors);
        that.elementsLength = that.elements.length;

        // If the elements are not found, return
        if (!that.elementsLength) return false;

        framework.on(window, 'load', function (e) {

            // Handle each of the given elements
            framework.each(that.elements, function (index) {

                var slide = that.elements[index];
                var slideItems = slide.querySelectorAll(that.options.slideItem);

                if (!slideItems) return true;

                framework.addClass(slide, 'init-slide');

                var activeIndex = 0;
                var slideItemsLength = slideItems.length - 1;
                var activeSlideIndex, nextSlideIndex;

                // Start first slide element
                framework.addClass(slideItems[0], 'slide-show slide-start');

                function updateActiveStatus() {
                    if (activeIndex < slideItemsLength) {
                        activeSlideIndex = slideItems[activeIndex];
                        nextSlideIndex = slideItems[++activeIndex];
                    } else {
                        activeSlideIndex = slideItems[activeIndex];
                        nextSlideIndex = slideItems[activeIndex = 0];
                    }

                    // Setup monitoring loop state

                    framework.removeClass(activeSlideIndex, 'slide-show');
                    framework.addClass(nextSlideIndex, 'slide-show slide-start');

                    setTimeout(function () {
                        framework.removeClass(activeSlideIndex, 'slide-start');
                    }, that.options.slideTransitionSpeed);
                }

                (function crossLoop() {
                    updateActiveStatus();
                    window.setTimeout(crossLoop, that.options.slideIntarvalTime);
                }());

            });
        });
    };

    this.init();
};
// ---------------------------------
// SlideMenu
// ---------------------------------
// Init
//
// var slideMenu = new SlideMenu({

//     animationType: 'slide' or 'fade',
//     windowScrollTarget: ...,
//     animationCss3: true,

//     // Element classes
//     slidemenuClass: 'slidemenu',
//     slidemenuContainerClass: 'slidemenu-container',
//     slidemenuButtonClass: 'slidemenu-button',
//     slidemenuOverlayClass: 'slidemenu-overlay',

//     // Event classes
//     slidemenuNoscrollClass: 'noscroll-slidemenu',
//     slidemenuOpenClass: 'open-slidemenu',
//     slidemenuInitClass: 'init-slidemenu',

//     slidemenuOverlayOpacity: 0.85,
//     slidemenuBreakpoint: 768,
//     slidemenuAnimationFrame: 16,

//     onLeaveOpen: function () {
//     },
//     afterLoadOpen: function () {
//     },
//     onLeaveClose: function () {
//     },
//     afterLoadClose: function () {
//     },
// });
// ---------------------------------
// Method
//
// slideMenu.open();
// slideMenu.close();
// slideMenu.init();
// slideMenu.reInit();
// slideMenu.destroy();
// slideMenu.reset();
// ---------------------------------

function SlideMenu(_options) {

    "use strict";

    var $html = document.getElementsByTagName('html')[0];
    var $body = document.body;

    // ---------------------------------
    // Frameworks
    // ---------------------------------

    // import '../../framework/src/framework.js';

    // ---------------------------------
    // Options
    // ---------------------------------

    this.options = {

        init: true,
        animationType: framework.setCustomProperty('--slidemenu-animation', null),
        windowScrollTarget: framework.windowScrollTarget,
        animationCss3: true,

        // Element classes
        slidemenuClass: 'slidemenu',
        slidemenuContainerClass: 'slidemenu-container',
        slidemenuButtonClass: 'slidemenu-button',
        slidemenuOverlayClass: 'slidemenu-overlay',

        // Event classes
        slidemenuNoscrollClass: 'noscroll-slidemenu',
        slidemenuOpenClass: 'open-slidemenu',
        slidemenuInitClass: 'init-slidemenu',
        slidemenuAnimationClass: 'animation-slidemenu',
        
        slidemenuOverlayOpacity: parseFloat(framework.setCustomProperty('--slidemenu-overlay-opacity', 0.85)),
        slidemenuBreakpoint: parseInt(framework.setCustomProperty('--slidemenu-breakpoint', 768)),
        slidemenuAnimationFrame: framework.value.animationFrameTime || parseInt(1000.0 / 60),

        onLeaveOpen: function () {
        },
        afterLoadOpen: function () {
        },
        onLeaveClose: function () {
        },
        afterLoadClose: function () {
        },
    };

    // Overwrite parameters
    for (var key in _options) {
        if (_options.hasOwnProperty(key)) {
            this.options[key] = _options[key];
        }
    }

    var that = this;

    that.scrollTop = 0;
    that.overlayOpacity = 0;
    that.resizeFlag = false;
    that.openFlag = false;
    that.firstOpenFlag = false;
    that.positionLeft = 0;
    that.opacity = 0;

    // ---------------------------------
    // Functions
    // ---------------------------------

    var isSlide = function () {
        return that.options.animationType === 'slide' ? true : false;
    };

    var pointRatio = function (ratio) {
        return that.options.slidemenuOverlayOpacity - (that.options.slidemenuOverlayOpacity * ratio);
    };

    var saveScrollPoition = function () {
        that.scrollTop = window.pageYOffset || that.options.windowScrollTarget.scrollTop;
    };

    // For event functions

    var opencloseMenu = function (e) {
        e.preventDefault();
        framework.toggleClass($html, that.options.slidemenuOpenClass);
        if (framework.hasClass($html, that.options.slidemenuOpenClass)) {

            // Save scroll position
            if (!that.firstOpenFlag) {
                that.firstOpenFlag = true;
                saveScrollPoition();
            }

            that.open();
        } else {
            that.close();
        }
    };

    var openMenu = function (e) {
        e.preventDefault();
        that.open();
    };
    
    var closeMenu = function (e) {
        e.preventDefault();
        that.close();
    };

    var switchInit = function (e) {
        if (window.innerWidth > that.options.slidemenuBreakpoint) {
            if (!that.resizeFlag) {
                that.resizeFlag = true;
                that.reset();
            }
        } else {
            that.resizeFlag = false;
            that.reInit();
        }
    };
    
    // ---------------------------------
    // Method
    // ---------------------------------

    var openAnimationLoop, closeAnimationLoop;

    this.open = function () {

        var slideWidth = that.slidemenu.offsetWidth;

        // Save scroll position
        saveScrollPoition();

        if (that.openFlag) {
            that.openFlag = false;
        }

        // Cancel close animation loop
        framework.cancelAnimationFrame(closeAnimationLoop);

        // On leave open
        that.options.onLeaveOpen();

        var openAnimation = function () {

            that.opacity = parseFloat(framework.getStyle(that.slidemenu, 'opacity'));
            that.positionLeft = framework.offset(that.slidemenu).left;
            if (isSlide()) {
                that.overlayOpacity = pointRatio(framework.offset(that.slidemenu).left / (-slideWidth));
            } else {
                that.overlayOpacity = that.options.slidemenuOverlayOpacity - pointRatio(that.opacity);
            }

            // Loop
            openAnimationLoop = framework.requestAnimationFrame(openAnimation, that.options.slidemenuAnimationFrame);

            if (!that.openFlag && (
                (isSlide() && that.positionLeft > (-slideWidth)) ||
                (!isSlide() && that.opacity > 0)
            )) {
                that.openFlag = true;

                // Stop css scroll animation
                that.scrollBehavior = framework.setStyle(that.options.windowScrollTarget, 'scroll-behavior', 'auto');

                // No scroll
                framework.addClass($html, that.options.slidemenuNoscrollClass);
                $body.style.marginTop = (-that.scrollTop) + 'px';
                
                // Setup status
                if (!that.options.animationCss3) {
                    framework.setStyle(that.slidemenuOverlay, 'visibility', 'visible');
                }
            }

            // Last attack 
            if (that.openFlag && (
                (isSlide() && (that.positionLeft === 0 || that.positionLeft === (-slideWidth))) ||
                (!isSlide() && (that.opacity === 0 || that.opacity === 1))
            )) {
                that.openFlag = false;

                // Cancel self animation loop
                framework.cancelAnimationFrame(openAnimationLoop);

                // After load open
                that.options.afterLoadOpen();

                // Case of double click
                if (that.opacity === 0 || that.positionLeft === (-slideWidth)) {
                    framework.removeClass($html, that.options.slidemenuNoscrollClass);
                    that.overlayOpacity = 0;
                }
                // Setup open status
                else if (that.opacity === 1 || that.positionLeft === 0) {
                }
            }

            if (!that.options.animationCss3) {
                framework.setStyle(that.slidemenuOverlay, 'opacity', that.overlayOpacity);
            }
        };
        openAnimation();
    };

    this.close = function () {

        var slideWidth = that.slidemenu.offsetWidth;
        
        if (!that.openFlag) {
            that.openFlag = true;

            // Remove open class
            framework.removeClass($html, that.options.slidemenuOpenClass);
        }

        // On leave close
        that.options.onLeaveClose();

        // Cancel open animation loop
        framework.cancelAnimationFrame(openAnimationLoop);

        var closeAnimation = function () {

            that.opacity = parseFloat(framework.getStyle(that.slidemenu, 'opacity'));
            that.positionLeft = framework.offset(that.slidemenu).left;
            if (isSlide()) {
                that.overlayOpacity = pointRatio(framework.offset(that.slidemenu).left / (-slideWidth));
            } else {
                that.overlayOpacity = that.options.slidemenuOverlayOpacity - pointRatio(that.opacity);
            }

            // Loop
            closeAnimationLoop = framework.requestAnimationFrame(closeAnimation, that.options.slidemenuAnimationFrame);

            // First attack
            if (that.openFlag && (
                (isSlide() && that.positionLeft < 0) ||
                (!isSlide() && that.opacity < 1)
            )) {
                that.openFlag = false;
            }

            // Last attack
            if (!that.openFlag && (
                (isSlide() && (that.positionLeft === 0 || that.positionLeft === (-slideWidth))) ||
                (!isSlide() && (that.opacity === 0 || that.opacity === 1))
            )) {
                that.openFlag = false;

                // Cancel self animation loop
                framework.cancelAnimationFrame(closeAnimationLoop);

                // After load close
                that.options.afterLoadClose();

                // Clear no scroll
                framework.removeClass($html, that.options.slidemenuNoscrollClass);
                $body.style.marginTop = 0;
                that.options.windowScrollTarget.scrollTop = that.scrollTop;

                // Setup open status
                if (that.opacity === 0 || that.positionLeft === (-slideWidth)) {
                    framework.removeClass($html, that.options.slidemenuNoscrollClass);
                    that.scrollBehavior = framework.setStyle(that.options.windowScrollTarget, 'scroll-behavior', that.scrollBehavior);

                    if (!that.options.animationCss3) {
                        framework.setStyle(that.slidemenuOverlay, 'visibility', 'hidden');
                    }
                }
                // Case of double click
                else if (that.opacity === 1 || that.positionLeft === 0) {
                }
            }

            if (!that.options.animationCss3) {
                framework.setStyle(that.slidemenuOverlay, 'opacity', that.overlayOpacity);
            }
        };
        closeAnimation();
    };
    
    this.reset = function () {

        that.firstOpenFlag = false;
        that.openFlag = false;

        // Remove classes
        framework.removeClass($html, that.options.slidemenuInitClass);
        framework.removeClass($html, that.options.slidemenuOpenClass);
        framework.removeClass($html, that.options.slidemenuNoscrollClass);
        if (that.options.animationCss3) framework.removeClass($html, that.options.slidemenuAnimationClass);

        // Revert to before init (Keep doms)
        framework.setStyle(that.options.windowScrollTarget, 'scroll-behavior', '');
        framework.setStyle(that.slidemenuOverlay, 'visibility', '');
        framework.setStyle(that.slidemenuOverlay, 'opacity', '');

        // Remove events
        framework.off(that.slidemenuButton, 'click', opencloseMenu);
        framework.off(that.slidemenuOverlay, 'click', closeMenu);
        
    };

    this.destroy = function () {

        that.reset();

        // Remove doms
        that.slidemenuOverlay.parentNode.removeChild(that.slidemenuOverlay);

        // Remove events
        framework.off(window, 'load resize', switchInit);
    };

    this.reInit = function () {
        
        // Add installed class name
        framework.addClass($html, that.options.slidemenuInitClass);
        if(that.options.animationCss3) framework.addClass($html, that.options.slidemenuAnimationClass);

        // Revival to before init (Keep doms)
        framework.setStyle(that.slidemenuOverlay, 'visibility', '');

        // Add events
        framework.on(that.slidemenuButton, 'click', opencloseMenu);
        framework.on(that.slidemenuOverlay, 'click', closeMenu);
    };

    this.init = function () {

        // Setup elements
        that.slidemenu = document.getElementsByClassName(that.options.slidemenuClass)[0];
        that.slidemenuContainer = document.getElementsByClassName(that.options.slidemenuContainerClass)[0];
        that.slidemenuButton = document.getElementsByClassName(that.options.slidemenuButtonClass)[0];

        // If the elements are not found, return
        if (!that.slidemenu || !that.slidemenuContainer || !that.slidemenuButton) return false;

        // Add installed class name
        framework.addClass($html, that.options.slidemenuInitClass);
        if(that.options.animationCss3) framework.addClass($html, that.options.slidemenuAnimationClass);

        // Save the value
        that.scrollBehavior = framework.getStyle(that.options.windowScrollTarget, 'scroll-behavior');

        // Create overlay element
        that.slidemenuOverlay = document.createElement('div');
        that.slidemenuOverlay.className = that.options.slidemenuOverlayClass;
        that.slidemenuContainer.appendChild(that.slidemenuOverlay);
        
        // Menu open / close event
        // ---------------------------------
        
        // Click button
        framework.on(that.slidemenuButton, 'click', opencloseMenu);

        // Click overlay
        framework.on(that.slidemenuOverlay, 'click', closeMenu);

        // Reset by window size
        framework.on(window, 'load resize', switchInit);
    };

    if (that.options.init) {
        this.init();
    }
}
;

// ---------------------------------
// Plugins
// ---------------------------------

// Lazyload
(function(window, factory) {
	var lazySizes = factory(window, window.document);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(window, function l(window, document) {
	'use strict';
	/*jshint eqnull:true */
	if(!document.getElementsByClassName){return;}

	var lazysizes, lazySizesConfig;

	var docElem = document.documentElement;

	var Date = window.Date;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	var addEventListener = window[_addEventListener];

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesConfig.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesConfig.throttleDelay;
		var rICTimeout = lazySizesConfig.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesConfig.ricTimeout){
					rICTimeout = lazySizesConfig.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesConfig)){
				lazySizesConfig[prop] = lazySizesDefaults[prop];
			}
		}

		window.lazySizesConfig = lazySizesConfig;

		setTimeout(function(){
			if(lazySizesConfig.init){
				init();
			}
		});
	})();

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || (getCSS(elem.parentNode, 'visibility') != 'hidden' && getCSS(elem, 'visibility') != 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				defaultExpand = (!lazySizesConfig.expand || lazySizesConfig.expand < 1) ?
					docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
					lazySizesConfig.expand;

				lazysizes._defEx = defaultExpand;

				preloadExpand = defaultExpand * lazySizesConfig.expFactor;
				hFac = lazySizesConfig.hFac;
				isBodyHidden = null;

				if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
					currentExpand = preloadExpand;
					lowRuns = 0;
				} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
					currentExpand = defaultExpand;
				} else {
					currentExpand = shrinkExpand;
				}

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesConfig.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesConfig.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesConfig.loadedClass);
			removeClass(elem, lazySizesConfig.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			try {
				elem.contentWindow.location.replace(src);
			} catch(e){
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);

			if( (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesConfig.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);
				src = elem[_getAttribute](lazySizesConfig.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesConfig.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesConfig.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				if( !firesLoad || (elem.complete && elem.naturalWidth > 1)){
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
			}, true);
		});

		var unveilElement = function (elem){
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass) && hasClass(elem, lazySizesConfig.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}
			var afterScroll = debounce(function(){
				lazySizesConfig.loadMode = 3;
				throttledCheckElements();
			});

			isCompleted = true;

			lazySizesConfig.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', function(){
				if(lazySizesConfig.loadMode == 3){
					lazySizesConfig.loadMode = 2;
				}
				afterScroll();
			}, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesConfig.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	lazysizes = {
		cfg: lazySizesConfig,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));
;
/*
This plugin extends lazySizes to lazyLoad:
background images, videos/posters and scripts

Background-Image:
For background images, use data-bg attribute:
<div class="lazyload" data-bg="bg-img.jpg"></div>

 Video:
 For video/audio use data-poster and preload="none":
 <video class="lazyload" data-poster="poster.jpg" preload="none">
 <!-- sources -->
 </video>

 Scripts:
 For scripts use data-script:
 <div class="lazyload" data-script="module-name.js"></div>


 Script modules using require:
 For modules using require use data-require:
 <div class="lazyload" data-require="module-name"></div>
*/

(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(require('lazysizes'));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	/*jshint eqnull:true */
	'use strict';
	var bgLoad, regBgUrlEscape;
	var uniqueUrls = {};

	if(document.addEventListener){
		regBgUrlEscape = /\(|\)|\s|'/;

		bgLoad = function (url, cb){
			var img = document.createElement('img');
			img.onload = function(){
				img.onload = null;
				img.onerror = null;
				img = null;
				cb();
			};
			img.onerror = img.onload;

			img.src = url;

			if(img && img.complete && img.onload){
				img.onload();
			}
		};

		addEventListener('lazybeforeunveil', function(e){
			if(e.detail.instance != lazySizes){return;}

			var tmp, load, bg, poster;
			if(!e.defaultPrevented) {

				if(e.target.preload == 'none'){
					e.target.preload = 'auto';
				}

				tmp = e.target.getAttribute('data-link');
				if(tmp){
					addStyleScript(tmp, true);
				}

				// handle data-script
				tmp = e.target.getAttribute('data-script');
				if(tmp){
					addStyleScript(tmp);
				}

				// handle data-require
				tmp = e.target.getAttribute('data-require');
				if(tmp){
					if(lazySizes.cfg.requireJs){
						lazySizes.cfg.requireJs([tmp]);
					} else {
						addStyleScript(tmp);
					}
				}

				// handle data-bg
				bg = e.target.getAttribute('data-bg');
				if (bg) {
					e.detail.firesLoad = true;
					load = function(){
						e.target.style.backgroundImage = 'url(' + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg ) + ')';
						e.detail.firesLoad = false;
						lazySizes.fire(e.target, '_lazyloaded', {}, true, true);
					};

					bgLoad(bg, load);
				}

				// handle data-poster
				poster = e.target.getAttribute('data-poster');
				if(poster){
					e.detail.firesLoad = true;
					load = function(){
						e.target.poster = poster;
						e.detail.firesLoad = false;
						lazySizes.fire(e.target, '_lazyloaded', {}, true, true);
					};

					bgLoad(poster, load);

				}
			}
		}, false);

	}

	function addStyleScript(src, style){
		if(uniqueUrls[src]){
			return;
		}
		var elem = document.createElement(style ? 'link' : 'script');
		var insertElem = document.getElementsByTagName('script')[0];

		if(style){
			elem.rel = 'stylesheet';
			elem.href = src;
		} else {
			elem.src = src;
		}
		uniqueUrls[src] = true;
		uniqueUrls[elem.src || elem.href] = true;
		insertElem.parentNode.insertBefore(elem, insertElem);
	}
}));
;

(function () {

    // Init pollyfill
    var pollyfill = new PollyFill();

    // Init slide menu sldmenu
    var slideMenu = new SlideMenu();

    // Init cross gallery
    var crossGallery = new CrossGallery('#slide');

    // Init news ticker
    var newsTicker = new NewsTicker('.ticker');
    var cursorBlinkTimes = 3;
    var cursorBlinkIntervalTime = ((newsTicker.options.itemSpeed - newsTicker.options.fadeOutSpeed) / newsTicker.options.fadeOutSpeed) * (100 / cursorBlinkTimes);

    // Blink the cursor
    newsTicker.newsShowAfter = function (container, text, cursor) {
        var timer_id, i = 0;
        timer_id = setInterval((function () {
            cursor.style.opacity ^= 1;
            i++;
            if (i === cursorBlinkTimes * 2) clearInterval(timer_id);
        }), cursorBlinkIntervalTime);
    };

})();
